import { useRef } from 'react';
import classnames from 'classnames';

import { useFadeIn } from 'utils/hooks';
import { useModal } from 'models/modal';
import { useUserData } from 'models/user';
import { useAuth } from 'models/auth';

import ButtonUI from 'components/atoms/ButtonUI';
import UserScore from 'components/atoms/UserScore';

import gift from 'images/icons/gift.png';
import rank from 'images/icons/rank.png';

import styles from './index.css';

export interface UserControlTopLayoutProp {
    className?: string;
    disabled: boolean;
    newGift: boolean;

    points: number;
    onOpenPointsRecord?: () => void;
    onOpenRank?: () => void;
}

export const UserControlTopLayout: React.FC<UserControlTopLayoutProp> = ({
    className,
    disabled,
    newGift,

    points,
    onOpenPointsRecord = () => {},
    onOpenRank = () => {},
}) => {
    const ref = useRef(null);

    useFadeIn([{ ref }]);

    return (
        <div
            ref={ref}
            className={classnames(styles.userControlTop, disabled && styles.disabled, className)}
        >
            <UserScore className={styles.score} pointNum={points} disabled={disabled} />
            <div className={styles.actions}>
                <ButtonUI
                    className={styles.button}
                    icon={gift}
                    text="積分獎勵"
                    onClick={onOpenPointsRecord}
                    notification={newGift}
                />
                <ButtonUI
                    className={styles.button}
                    icon={rank}
                    text="排行榜"
                    onClick={onOpenRank}
                />
            </div>
        </div>
    );
};

export interface UserControlTopProp {
    className?: string;
}

const UserControlTop: React.FC<UserControlTopProp> = ({ className }) => {
    const disabled = false;

    const [{ loginType }] = useAuth();
    const [, { openModal }] = useModal();
    const [{ redeemPoints, totalPoints }] = useUserData();

    return (
        <UserControlTopLayout
            className={className}
            disabled={disabled}
            points={totalPoints}
            newGift={Math.floor(totalPoints / 1000) > redeemPoints.length}
            onOpenPointsRecord={() => {
                if (loginType === 'facebook') {
                    openModal({ type: 'userPoints' });
                } else {
                    openModal({ type: 'needLogin' });
                }
            }}
            onOpenRank={() => {
                openModal({ type: 'rank' });
            }}
        />
    );
};

export default UserControlTop;
